import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import UnitBookedModal from "./UnitBookedModal";

const CardModal = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [bookedModalshow, setBookedModalShow] = useState(false);
  const handler = () => {
    setBookedModalShow(true);
    props.onHide();
  };
  return (
    <>
      <Modal show={props.show} onHide={props.onHide}>
        <Modal.Header closeButton></Modal.Header>

        <div className="modal-body space-y-20 pd-40">
          <h4 className="pb-5">{props.title}</h4>

          <div className="hr"></div>
          <div className="d-flex justify-content-between">
            <p> Project Name:</p>
            <p className="text-right price color-popup"> Meezo </p>
          </div>
          <div className="d-flex justify-content-between">
            <p> Tower/Block:</p>
            <p className="text-right price color-popup"> A </p>
          </div>
          <div className="d-flex justify-content-between">
            <p> Level/Floor:</p>
            <p className="text-right price color-popup"> 28 </p>
          </div>
          <div className="d-flex justify-content-between">
            <p> Unit Number:</p>
            <p className="text-right price color-popup"> 6 </p>
          </div>
          <div className="d-flex justify-content-between">
            <p> Unit Price:</p>
            <p className="text-right price color-popup"> 600RM </p>
          </div>
          <p className="text-center pt-3">
            Kindly confirm the information for your booking is correct{" "}
          </p>
          <Link
            to="#"
            className="btn btn-primary my-3"
            data-toggle="modal"
            data-target="#popup_bid_success"
            data-dismiss="modal"
            aria-label="Close"
            onClick={props.onHide}
          >
            {" "}
            Back
          </Link>
          <Link
            to="#"
            className="btn btn-primary "
            data-toggle="modal"
            data-target="#popup_bid_success"
            data-dismiss="modal"
            aria-label="Close"
            onClick={handler}
          >
            {" "}
            Confirm
          </Link>
        </div>
      </Modal>
      <UnitBookedModal
        show={bookedModalshow}
        onHide={() => setBookedModalShow(!bookedModalshow)}
        title="Congrats Property Booked"
        para={"You successfully booked this property "}
        handleActiveTab={props.handleActiveTab}
      />
    </>
  );
};

export default CardModal;
